import classNames from "classnames";
import styles from "./style.module.scss";
import ModalWrapper from "../modalWrapper";
import ModalHeader from "../modalHeader";
import CustomButton from "../customButton";

interface CustomModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onNext?: () => void;
  title?: string;
  description?: string | any;
  icon?: any;
  iconStyle?: any;
  iconContainerStyle?: any;
  showBackButton?: boolean;
  onBack?: () => void;
  onCancel?: () => void;
  size?: "sm" | "md" | "lg" | "xl" | "xxl";
  customContentContainer?: any;
  showModalFooter?: boolean;
  showModalHeader?: boolean;
  actionButtonText?: string;
  cancelButtonText?: string;
  cancelButtonContainerStyle?: any;
  cancelButtonTitleStyle?: any;
  actionButtonContainerStyle?: any;
  actionButtonTitleStyle?: any;
  actionButtonIcon?: any;
  actionButtonIconStyle?: any;
  loading?: boolean;
  actionButtonLoading?: boolean;
  actionButtonDisabled?: boolean;
  cancelButtonDisabled?: boolean;
  showCancelButton?: boolean;
  showHeaderBorder?: boolean;
  showFooterBorder?: boolean;
  showCloseIcon?: boolean;
}

const CustomModal = ({
  children,
  isOpen,
  onClose,
  onNext,
  title,
  description,
  icon,
  iconStyle,
  actionButtonIcon,
  actionButtonIconStyle,
  iconContainerStyle,
  showBackButton = false,
  showModalHeader = false,
  onBack,
  onCancel,
  size = "md",
  customContentContainer,
  showModalFooter = false,
  actionButtonText = "Submit",
  cancelButtonText = "Cancel",
  // cancelButtonContainerStyle = "",
  // cancelButtonTitleStyle,
  actionButtonContainerStyle = "",
  actionButtonTitleStyle,
  loading,
  actionButtonLoading,
  actionButtonDisabled,
  cancelButtonDisabled,
  showCancelButton = true,
  showHeaderBorder = true,
  showFooterBorder = true,
  showCloseIcon = true,
}: CustomModalProps) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper>
      <div
        className={classNames(
          styles.contentContainer,
          styles[size],
          customContentContainer,
        )}
      >
        {showModalHeader && (
          <ModalHeader
            title={title}
            description={description || ""}
            Icon={icon}
            iconStyle={iconStyle}
            iconContainerStyle={iconContainerStyle}
            isBack={showBackButton}
            handleClose={onClose}
            handleBack={onBack}
            showBottomBorder={showHeaderBorder}
            showClose={showCloseIcon}
          />
        )}

        <div className="modalContent">{children}</div>
        {showModalFooter && (
          <div
            className={classNames(
              styles.modalFooter,
              "md:flex-row flex flex-col items-center gap-3 justify-center w-full",
              !showFooterBorder && styles.modalFooterNoBorder,
            )}
          >
            {showCancelButton && (
              <CustomButton
                title={cancelButtonText}
                //containerStyle={cancelButtonContainerStyle}
                titleStyle={styles.cancelTitle}
                onClick={onCancel || onClose}
                disabled={cancelButtonDisabled}
                containerStyle={styles.cancelButton}
                className="w-full"
              />
            )}

            <CustomButton
              title={actionButtonText}
              containerStyle={actionButtonContainerStyle}
              titleStyle={actionButtonTitleStyle}
              onClick={() => {
                onNext?.();
              }}
              loading={actionButtonLoading || loading}
              disabled={actionButtonDisabled || loading}
              Icon={actionButtonIcon}
              iconStyle={actionButtonIconStyle || styles.icon}
              IconDirection="left"
              className="w-full"
            />
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};

export default CustomModal;
